var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShareIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_27226",
    "data-name": "Group 27226",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2871",
    "data-name": "Rectangle 2871",
    width: 24,
    height: 24,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_27225",
    "data-name": "Group 27225",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37813",
    "data-name": "Path 37813",
    d: "M23.472,12.2a3.177,3.177,0,1,1,3.176-3.177A3.181,3.181,0,0,1,23.472,12.2m0-4.554a1.377,1.377,0,1,0,1.376,1.377,1.378,1.378,0,0,0-1.376-1.377",
    transform: "translate(-8.118 -2.34)",
    fill: "#fc3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37814",
    "data-name": "Path 37814",
    d: "M8.292,21.059a3.177,3.177,0,1,1,3.177-3.177,3.181,3.181,0,0,1-3.177,3.177m0-4.554a1.377,1.377,0,1,0,1.377,1.377,1.378,1.378,0,0,0-1.377-1.377",
    transform: "translate(-2.046 -5.882)",
    fill: "#fc3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37815",
    "data-name": "Path 37815",
    d: "M23.472,29.914a3.177,3.177,0,1,1,3.176-3.177,3.181,3.181,0,0,1-3.176,3.177m0-4.554a1.377,1.377,0,1,0,1.376,1.377,1.378,1.378,0,0,0-1.376-1.377",
    transform: "translate(-8.118 -9.424)",
    fill: "#fc3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37816",
    "data-name": "Path 37816",
    d: "M18.27,25.231a.9.9,0,0,1-.452-.123l-5.184-3.02a.9.9,0,0,1,.907-1.555l5.184,3.021a.9.9,0,0,1-.454,1.678",
    transform: "translate(-4.875 -8.164)",
    fill: "#fc3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37817",
    "data-name": "Path 37817",
    d: "M13.087,16.376a.9.9,0,0,1-.454-1.677l5.176-3.021a.9.9,0,0,1,.907,1.555l-5.176,3.02a.892.892,0,0,1-.452.123",
    transform: "translate(-4.875 -4.622)",
    fill: "#fc3"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/share-icon.78b3ce477370257312a3c855a3aea540.svg";
export { ForwardRef as ReactComponent };